import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className
}) => {
  if (!isOpen) return null;
  if (typeof document === "undefined") return null;

  return createPortal(
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className={cn(
        "fixed z-50 bg-white rounded-2xl overflow-hidden max-h-[90vh] overflow-y-auto w-[95%] sm:max-w-md left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 shadow-md",
        className
      )} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        {title && (
          <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-4 py-3 flex justify-between items-center">
            <h2 className="font-semibold text-lg text-gray-900">{title}</h2>
            <button 
              onClick={onClose}
              className="p-1 rounded-full hover:bg-muted"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        )}
        
        {/* Content */}
        <div className="p-4">
          {children}
        </div>
        
        {/* Safe area spacing for mobile */}
        <div className="h-6" />
      </div>
    </>,
    document.body
  );
};

export default Modal;
